import { styled } from "@mui/material";

export const TeamDirectoryWrapper = styled('div')({
    marginTop: "40px",
    display: "flex",
    justifyContent: "space-between"
});

export const TeamDirectoryLeft = styled('div')({
    display: "flex",
    flexDirection: "column",
    flex: 0.6,
    gap: "30px"
});

export const TeamDirectoryRight = styled('div')({
    flex: 0.4,
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end",
    maxWidth: "358px",
    gap: "30px",
    position: "sticky",
    top: "123.2pz"
});

export const TeamDirectorySectionTitle = styled('h2')({
    fontSize: "24px",
    color: "black",
    margin: 0
});

export const TeamDirectorySectionItem = styled('div')({
    display: "flex",
    gap: "21px 64px",
    marginTop: "18px",
    flexWrap: "wrap",
});

export const TeamDirectoryMember = styled('div')({
    display: "flex",
    alignItems: "center",
    gap: "12px",
    width: "285px",
});

export const TeamDirectoryMemberProfile = styled('div')({
    width: "50px",
    height: "50px",
    borderRadius: "1000px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    overflow: "hidden",
    flexShrink: 0,
    "& span": {
        fontSize: "14px",
        color: "#000000",
        fontWeight: "bold"
    },
    "& svg": {
        flexShrink: "0"
    },
    "& img": {
        width: "50px",
        height: "50px",
        borderRadius: "50%",
        objectFit: "cover",
    },
    "&.no-image": {
        background: "pink",
    }
});

export const TeamDirectoryMemberProfileInfo = styled('div')({
   display: "flex",
   flexDirection: "column"
});

export const TeamDirectoryMemberName = styled('div')({
    fontSize: "16px",
    fontWeight: "bold",
    color: "black",
});

export const TeamDirectoryMemberDesignation = styled('div')({
    fontSize: "12px",
    fontWeight: "bold",
    color: "#424242",
});

export const TeamDirectoryRightCard = styled('div')({
    width: "100%",
    padding: "22px",
    // background: "white",
    background: "linear-gradient(148.5deg, #EB0A1E -3.34%, #000000 81%)",
    position: "relative",
    borderRadius: "8px",
    "&::after": {
        content: '""',
        position: "absolute",
        top: "4px",
        left: "4px",
        right: "4px",
        bottom: "4px",
        background: "white",
        zIndex: "2",
        borderRadius: "4px",
    }
});

export const TeamDirectoryRightCardTitle = styled('div')({
   fontSize: "24px",
   color: "#00000",
   fontWeight: "bold",
   position: "relative",
   zIndex: "3",
});

export const TeamDirectoryRightCardProfiles = styled('div')({
    marginTop: "15px",
    display: "flex",
    flexDirection: "column",
    gap: "21px",
    position: "relative",
    zIndex: "3",
 });
 
 export const TeamDirectoryRightCardProfile = styled('div')({
    display: "flex",
    alignItems: "center",
    gap: "12px",
    width: "285px",
    position: "relative",
    zIndex: "3",
 });
 
 export const TeamDirectoryRightCardProfileImg = styled('div')({
    width: "50px",
    height: "50px",
    borderRadius: "1000px",
    background: "pink",
    position: "relative",
    zIndex: "3",
 });
 
 export const TeamDirectoryRightCardProfileName = styled('div')({
    fontSize: "16px",
    fontWeight: "bold",
    color: "#000000",
    position: "relative",
    zIndex: "3",
 });
 
 export const TeamDirectoryRightCardProfileDesignation = styled('div')({
    fontSize: "12px",
    fontWeight: "bold",
    color: "##424242",
    position: "relative",
    zIndex: "3",
 });
 
 export const TeamDirectoryRightCardProfileInfo = styled('div')({
    display: "flex",
    flexDirection: "column",
    position: "relative",
    zIndex: "3",
 });

 export const TeamDirectoryRightCardInfo = styled('div')({
    marginTop: "15px",
    position: "relative",
    zIndex: "3",
 });
 
 export const TeamDirectoryRightCardEmailTitle = styled('div')({
    color: "#fff",
    fontWeight: "bold",
    fontSize: "16px",
    position: "relative",
    zIndex: "3",
 });
 
export const TeamDirectoryRightCardEmail = styled('a')({
    color: "#FFFCFC",
    fontWeight: "bold",
    fontSize: "12px",
    position: "relative",
    zIndex: "3",
 });
